export const spectoCalendarTranslations = {
  'spectoCalendarTranslations.linkEmployerDashboard': 'Dashboard',
  'spectoCalendarTranslations.linkInterviewInvitation': 'Interview invitations',
  'spectoCalendarTranslations.linkSearchCandidates': 'Search Candidates',
  'spectoCalendarTranslations.linkCandidateDashboard': 'Dashboard',
  'spectoCalendarTranslations.linkAllRequests': 'All requests',
  'spectoCalendarTranslations.linkEditCV': 'My CV',
}
